import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const MapMarkerPinBase = (
  <g fill='currentColor'>
    <path
      fill='#fff'
      d='M16.734 29.637l-.767-.641.767.641zm-1.468 0l-.767.642.767-.642zM25 13.375c0 .984-.367 2.27-1.035 3.76-.66 1.469-1.573 3.046-2.571 4.583-1.996 3.074-4.284 5.91-5.427 7.278l1.534 1.283c1.165-1.394 3.51-4.3 5.57-7.471 1.03-1.586 2.001-3.258 2.718-4.854C26.497 16.377 27 14.78 27 13.375h-2zM16 4c4.936 0 9 4.162 9 9.375h2C27 7.128 22.11 2 16 2v2zm-9 9.375C7 8.162 11.064 4 16 4V2C9.89 2 5 7.128 5 13.375h2zm9.033 15.621c-1.143-1.368-3.43-4.204-5.427-7.278-.998-1.537-1.91-3.114-2.57-4.584C7.365 15.646 7 14.36 7 13.375H5c0 1.406.503 3.002 1.211 4.579.717 1.596 1.688 3.268 2.718 4.854 2.06 3.171 4.405 6.077 5.57 7.47l1.534-1.282zm-.066 0l.01-.006c.007-.003.015-.005.023-.005s.016.002.023.005c.009.004.012.008.01.006L14.5 30.279c.787.941 2.215.941 3.002 0l-1.534-1.283zm1.758-15.623c0 1.046-.807 1.83-1.727 1.83v2c2.093 0 3.727-1.75 3.727-3.83h-2zm-1.727-1.829c.92 0 1.727.784 1.727 1.83h2c0-2.08-1.634-3.83-3.727-3.83v2zm-1.726 1.83c0-1.046.807-1.83 1.726-1.83v-2c-2.092 0-3.726 1.75-3.726 3.83h2zm1.726 1.829c-.919 0-1.726-.784-1.726-1.83h-2c0 2.08 1.634 3.83 3.726 3.83v-2z'
    />
    <path d='M16.734 29.637C19.042 26.876 26 18.155 26 13.375 26 7.645 21.523 3 16 3S6 7.645 6 13.375c0 4.78 6.958 13.5 9.266 16.262.387.464 1.08.464 1.468 0zm-.736-13.434c1.506 0 2.727-1.267 2.727-2.83 0-1.562-1.22-2.829-2.727-2.829-1.506 0-2.726 1.267-2.726 2.83 0 1.562 1.22 2.829 2.726 2.829z' />
    <circle cx='15.604' cy='13.103' r='2.483' fill='#fff' />
  </g>
)

export const MapMarkerPin = createIcon({
  displayName: 'MapMarkerPin',
  viewBox: '0 0 32 32',
  path: MapMarkerPinBase,
})

export const MapMarkerPinBase2 = (
  <g fill='currentColor'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='m20 39.425-2.094-1.829C9.483 30.242 4.676 23.408 4.676 16.99 4.677 8.061 11.683 1.666 20 1.666c8.317 0 15.323 6.395 15.323 15.322 0 6.419-4.806 13.253-13.229 20.607L20 39.426zm0-2.212.998-.872c8.392-7.328 12.658-13.727 12.658-19.352C33.656 9.024 27.44 3.333 20 3.333c-7.44 0-13.657 5.691-13.657 13.656 0 5.625 4.266 12.024 12.659 19.352l.998.871z'
      fill='#fff'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='m20.998 36.341-.998.872-.998-.872C10.61 29.013 6.344 22.614 6.344 16.99 6.344 9.025 12.56 3.334 20 3.334s13.657 5.69 13.657 13.656c0 5.624-4.266 12.023-12.659 19.351z'
    />
    <circle cx='20' cy='16' r='4' fill='#fff' />
  </g>
)

export const MapMarkerPin2 = createIcon({
  displayName: 'MapMarkerPin2',
  viewBox: '0 0 40 40',
  path: MapMarkerPinBase2,
})

export const MapMarkerCircleBase = (
  <g fill='currentColor'>
    <circle cx='16' cy='16' r='10.667' />
    <circle cx='16' cy='16' r='11.167' stroke='#fff' />
    <circle cx='16' cy='16' r='2.667' fill='#fff' />
  </g>
)

export const MapMarkerCircle = createIcon({
  displayName: 'MapMarkerCircle',
  viewBox: '0 0 32 32',
  path: MapMarkerCircleBase,
})

export const MapMarkerCircleBase2 = (
  <g opacity='0.85'>
    <circle cx='16' cy='16' r='11.167' stroke='#fff' />
    <circle cx='16' cy='16' r='10.667' fill='#99C8EE' />
    <circle cx='16' cy='16' r='5.333' fill='#1266C7' />
  </g>
)

export const MapMarkerCircle2 = createIcon({
  displayName: 'MapMarkerCircle2',
  viewBox: '0 0 32 32',
  path: MapMarkerCircleBase2,
})
